import SignUp from './SignUp'

export default SignUp



// WEBPACK FOOTER //
// ./src/views/SignUp/index.js